import React from "react";
import { Divider, Flex } from "@chakra-ui/react";
import useOrderHistoryDetail from "@/features/my-order/features/order-history/hooks/useOrderHistoryDetail";
import OrderHistoryInvoiceSummary from "@/features/my-order/features/order-history/components/invoice-section/OrderHistoryInvoiceSummary";
import OrderHistoryInvoiceProductPaymentArticle from "@/features/my-order/features/order-history/components/invoice-section/OrderHistoryInvoiceProductPaymentArticle";
import OrderHistoryInvoiceDepositArticle from "@/features/my-order/features/order-history/components/invoice-section/OrderHistoryInvoiceDepositArticle";
import OrderHistoryInvoiceIncidentalExpensesArticle from "@/features/my-order/features/order-history/components/invoice-section/OrderHistoryInvoiceIncidentalExpensesArticle";
import OrderHistoryInvoiceUnoFeeArticle from "@/features/my-order/features/order-history/components/invoice-section/OrderHistoryInvoiceUnoFeeArticle";
import { LightPayment } from "@/features/invoices/payment/payment.type";
import { toCamelKeyObject } from "@/utils/case";

function OrderHistoryInvoiceContent() {
  const { data } = useOrderHistoryDetail();
  const { expected_adjustment_count, remitted_amount, unremitted_count } =
    data?.statistic_by_payment ?? {};

  // 서버 remitted_amount 는 바이어 → 에이전시 송금액을 통화 구분 없이 더한다 — 바이어 유로 송금
  // 프로포마가 섞이면 원화에 유로가 더해지므로, 같은 결제 목록에서 통화별로 다시 더한다.
  const remittedAmountByCurrency = { KRW: 0, EUR: 0 };
  (data?.payments ?? []).forEach((rawPayment) => {
    const payment = toCamelKeyObject(rawPayment) as LightPayment;
    if (
      payment.sender?.type !== "BUYER" ||
      payment.receiver?.type !== "AGENCY" ||
      !((payment.remittedAmount?.value ?? 0) > 0)
    )
      return;
    const code = payment.remittedAmount.currency === "EUR" ? "EUR" : "KRW";
    remittedAmountByCurrency[code] += payment.remittedAmount.value;
  });
  const hasPayments = (data?.payments ?? []).length > 0;

  return (
    <Flex flexDirection={"column"} gap={"20px"}>
      <OrderHistoryInvoiceSummary
        remittedAmount={
          hasPayments ? remittedAmountByCurrency.KRW : remitted_amount ?? 0
        }
        remittedEurAmount={hasPayments ? remittedAmountByCurrency.EUR : 0}
        expectedAdjustmentReturn={expected_adjustment_count ?? 0}
        unRemittedCount={
          Object.values(unremitted_count ?? {}).reduce<number>(
            (acc, val) => acc + (val ?? 0),
            0
          ) ?? 0
        }
      />
      <Flex flexDirection={"column"} gap={"24px"}>
        <OrderHistoryInvoiceDepositArticle />
        <OrderHistoryInvoiceProductPaymentArticle />
        <Divider variant={"dashed"} color={"#D4D4D1"} opacity={1} />
        <OrderHistoryInvoiceIncidentalExpensesArticle />
        <OrderHistoryInvoiceUnoFeeArticle />
      </Flex>
    </Flex>
  );
}

export default OrderHistoryInvoiceContent;
